module.exports = __webpack_public_path__ + "static/img/case_detail_12_3.4b9880e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_12_3.png
// module id = OEuv
// module chunks = 34